import { useMemo } from 'react'
import { useRecurrencyAccess } from '@cannect/services/resources/recurrency/hooks'
import { PATIENT_SIDE_PANEL, SIDE_PANEL_MY_SUBSCRIPTIONS } from '../constants/patient'
import { SIDE_PANEL_MY_ORDERS } from '../constants/shared'

// Menu do paciente: "Minhas assinaturas" logo depois de "Meus pedidos", só para
// quem tem ou teve assinatura (useRecurrencyAccess().showNavigation).
export const usePatientSidePanel = () => {
  const { showNavigation } = useRecurrencyAccess()

  return useMemo(() => {
    if (!showNavigation) return PATIENT_SIDE_PANEL
    const ordersIndex = PATIENT_SIDE_PANEL.findIndex((item) => item.title.label === SIDE_PANEL_MY_ORDERS.title.label)
    const at = ordersIndex >= 0 ? ordersIndex + 1 : PATIENT_SIDE_PANEL.length
    return [...PATIENT_SIDE_PANEL.slice(0, at), SIDE_PANEL_MY_SUBSCRIPTIONS, ...PATIENT_SIDE_PANEL.slice(at)]
  }, [showNavigation])
}
